var options = {
    container: 'map',
    center: [170.5, 36.6],
    zoom: 1.68,
    interactive: false,
    // maxZoom: 10.4,
    // minZoom: 9,
    // maxBounds:[
    //   [120.6,29.8],
    //   [124.5,33.2]
    // ],
    preserveDrawingBuffer: true,
    style: {
        "glyphs": "./static/map/font/{fontstack}/{range}.pbf",
        // "glyphs":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
        "version": 8,
        "sources": {
            "t": {
                "type": "raster",
                'tiles': ['http://mt0.google.cn/vt/v=w2.114&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}'],
                //          'tiles': ['http://mt0.google.cn/vt/v=w2.114&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}'],
                'tileSize': 256
            },
            "gTiles": {
                "type": "raster",
                'tiles': ['http://mt0.google.cn/vt/v=w2.114&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}'],
                'tileSize': 256
            },
            "gsTiles": {
                "type": "raster",
                'tiles': ['http://mt0.google.cn/vt/lyrs=s@148,h@183000000&x={x}&y={y}&z={z}'],
                'tileSize': 256
            },
            "bTiles": {
                "type": "raster",
                'tiles': ['http://chart1.boloomo.com/Chinese/base/{z}/{x}/{y}.png'],
                'tileSize': 256
            },
            "port": {
                "type": "raster",
                'tiles': ['http://map.unmeteo.com/geoserver/gwc/service/wmts?layer=unmeteo%3Abs_port&style=&tilematrixset=EPSG%3A900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix=EPSG%3A900913%3A{z}&TileCol={x}&TileRow={y}'],
                'tileSize': 256
            },
            "ais": {
                "type": "raster",
                'tiles': ['http:/map.unmeteo.com/geoserver/gwc/service/wmts?layer=unmeteo%3Asp_ais5&style=&tilematrixset=EPSG%3A900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix=EPSG%3A900913%3A{z}&TileCol={x}&TileRow={y}'],
                'tileSize': 256
            },
            "defaultTiles": {
                "type": "raster",
                'tiles': ['/{z}-{y}-{x}.cc'],
                'tileSize': 256
            },
            "defTiles3": {
                "type": "raster",
                'tiles': ["http://map.unmeteo.com/geoserver/gwc/service/wmts?layer=unmeteo%3Acountry&style=&tilematrixset=EPSG%3A900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix=EPSG%3A900913%3A{z}&TileCol={x}&TileRow={y}"],
                'tileSize': 256
            },
            "states": {
                "type": "geojson",
                "data": "static/json/map.json"
            },
            "skyS": {
                "type": "geojson",
                "data": {
                    "type": "FeatureCollection",
                    "features": []
                }
            },
            "at0s": {
                "type": "raster",
                'tileSize': 256
            },
            "temperature": {
                "type": "raster",
                'tileSize': 256
            },
            "nearSea": {
                "type": "raster",
                // 'tiles': ["http://unimet.picp.io:8082/geoserver/gwc/service/wmts?layer=osm%3Aosm&style=&tilematrixset=EPSG%3A900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix=EPSG%3A900913%3A{z}&TileCol={x}&TileRow={y}"],
                'tiles': ["/geoserver/gwc/service/wmts?layer=openSM%3Aosm&style=&tilematrixset=EPSG%3A900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix=EPSG%3A900913%3A{z}&TileCol={x}&TileRow={y}"],
                'tileSize': 256
            },
            "shangHaiArea": {
                "type": "raster",
                'tiles': ["/geoserver/gwc/service/wmts?layer=osm%3Ac_squre&style=&tilematrixset=EPSG%3A900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix=EPSG%3A900913%3A{z}&TileCol={x}&TileRow={y}"],
                "tileSize": 256,
            }
        },
        "layers": [
            {
                "id": "unimet",
                "type": "raster",
                // "source": "nearSea",
                "source": "gTiles",
                "layout": {
                    'visibility': 'visible'
                }
            },
            {
                "id": 'unimet_shangHai_area',
                "type": 'raster',
                "source": "shangHaiArea",
                "layout": {
                    'visibility': 'visible'
                }
            },
        ]
    }
};
export default options;



//////////////////
// WEBPACK FOOTER
// ./src/util/map/mapOptions.ts
// module id = null
// module chunks = 